import { ThemeProvider } from '@material-ui/core';
import { Provider } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './App.scss';
import { theme } from './dashboard/theme';
import Routes from './Routes';
import store from './store/store';

const App = () => {
  return (
    <div className="App">
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <Routes />
        </ThemeProvider>
      </Provider>
    </div>
  );
};

export default withRouter(App);
